module.exports = __webpack_public_path__ + "portal-static/img/paihangbang2.05efc8c9.png";